/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Stage_SelectInputs */

const cs_deals_stage_select = /** @type {(inputs: Deals_Stage_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze`)
};

const en_deals_stage_select = /** @type {(inputs: Deals_Stage_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage`)
};

/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Deals_Stage_SelectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_stage_select = /** @type {((inputs?: Deals_Stage_SelectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Stage_SelectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_stage_select(inputs)
	return cs_deals_stage_select(inputs)
});